import { getTranslationByPartnerAccess } from '../../../../helpers/getTranslationByPartnerAccess'
import { ITranslationOptions } from '../../../../models/translationOptions'
import { TRANSLATION_KEYS } from '../translations'

export const getDemoUnitsInputLabelTranslation = ({
  isRetail,
  isDistributor,
}: ITranslationOptions) => {
  return getTranslationByPartnerAccess(TRANSLATION_KEYS.demoUnitsInput, {
    isRetail,
    isDistributor,
  })
}
